import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { usePagination } from "../../shared/hooks/usePagination";
import { handleError } from "../../shared/functions/handleError";
import { Box, Button, Card, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import CustomDataGrid from "../../shared/components/CustomDataGrid";
import { IEmailList } from "../../shared/interfaces/email-list/IEmailList";
import { AdminEmailListService } from "./service";
import { useEmailListColumns } from "./hooks/useEmailListColumns";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import EmailListUploadModal from "./components/EmailListUploadModal";

const AdminEmailList = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<IEmailList[] | undefined>(undefined);
  const columns = useEmailListColumns();
  const [isUploadModalOpened, setIsUploadModalOpened] = useState(false);
  const {
    pagination,
    count,
    setPagination,
    totalPages,
    setTotalPages,
    setCount,
    changeFilterHandler,
    handleUpdateList,
  } = usePagination({
    perPage: 30,
  });

  const handleCloseUploadModal = () => {
    setIsUploadModalOpened(false);
    handleUpdateList();
  };

  useEffect(() => {
    AdminEmailListService.get({ ...pagination, page: pagination?.page + 1 })
      .then((response) => {
        setCount(response?.count);
        setTotalPages(Math.ceil(response?.count / response?.perPage));
        setData(response.data);
      })
      .catch(handleError);
  }, [pagination, setTotalPages, setCount]);
  return (
    <Card sx={{ marginTop: "30px" }}>
      <Box
        sx={{
          pb: "20px",
        }}
      >
        <Grid container spacing={2} sx={{ alignItems: "center" }}>
          <Grid size={{ xs: 12, md: 6, lg: 3 }}>
            <TextField
              onChange={(e) => {
                changeFilterHandler("name", e.target.value);
              }}
              label={t("general.searchByName")}
              fullWidth
            />
          </Grid>
          <Grid
            size={{ xs: 12, md: 6, lg: 9 }}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant={"contained"}
              onClick={() => setIsUploadModalOpened(true)}
              sx={{ width: { xs: "100%", md: "auto" } }}
            >
              <AddCircleOutlineOutlinedIcon sx={{ marginRight: "5px" }} />
              {t("button.addNewEmailList")}
            </Button>
          </Grid>
        </Grid>
      </Box>
      <CustomDataGrid
        columns={columns}
        rows={data || []}
        rowCount={count}
        setPagination={setPagination}
        pagination={pagination}
        loading={data === undefined}
        hasNextPage={totalPages < pagination?.page}
      />
      <EmailListUploadModal
        open={isUploadModalOpened}
        handleClose={handleCloseUploadModal}
      />
    </Card>
  );
};

export default AdminEmailList;
